import React from "react";
import { ProductConsumer } from "../../Context/AddProWakel";
import { MODEL_LABELS, ACTION_LABELS } from "./auditFields";

const MODEL_OPTIONS = [
    { value: "", label: "هەموو بەشەکان" },
    ...Object.keys(MODEL_LABELS)
        .filter((key) => key !== "PriceUpdate")
        .map((key) => ({ value: key, label: MODEL_LABELS[key] })),
];

const ACTION_OPTIONS = [
    { value: "", label: "هەموو کردارەکان" },
    { value: "UPDATE", label: ACTION_LABELS.UPDATE },
    { value: "DELETE", label: ACTION_LABELS.DELETE },
];

const FillDetailAuditLog = () => (
    <ProductConsumer>
        {(value) => {
            const {
                AL_from,
                AL_to,
                AL_action,
                AL_model,
                AL_search,
                AL_searchTerm,
                AL_page,
                AL_pages,
                AL_total,
                AL_matchCount,
                AL_truncated,
                AL_applyFilter,
                AL_changeFilter,
                AL_onSearchChange,
                AL_pageplusone,
                AL_pageminsone,
                AddProChange,
            } = value;

            const searching = (AL_searchTerm || "").trim() !== "";

            return (
                <div className="rs-toolbar">
                    <h5 className="rs-toolbar__title">
                        <i className="fas fa-history"></i>
                        بەشی وردبینی
                    </h5>

                    <span className="rs-toolbar__sep" />

                    <div className="rs-field">
                        <label className="rs-field__label" htmlFor="AL_model">
                            بەش
                        </label>
                        <select
                            id="AL_model"
                            name="AL_model"
                            value={AL_model}
                            onChange={AL_changeFilter}
                            className="rs-select"
                        >
                            {MODEL_OPTIONS.map((opt) => (
                                <option key={opt.value} value={opt.value}>
                                    {opt.label}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="rs-field">
                        <label className="rs-field__label" htmlFor="AL_action">
                            کردار
                        </label>
                        <select
                            id="AL_action"
                            name="AL_action"
                            value={AL_action}
                            onChange={AL_changeFilter}
                            className="rs-select"
                        >
                            {ACTION_OPTIONS.map((opt) => (
                                <option key={opt.value} value={opt.value}>
                                    {opt.label}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="rs-field">
                        <label className="rs-field__label" htmlFor="AL_from">
                            لە بەرواری
                        </label>
                        <input
                            id="AL_from"
                            type="date"
                            name="AL_from"
                            value={AL_from}
                            onChange={AddProChange}
                            className="rs-input"
                        />
                    </div>

                    <div className="rs-field">
                        <label className="rs-field__label" htmlFor="AL_to">
                            تا بەرواری
                        </label>
                        <input
                            id="AL_to"
                            type="date"
                            name="AL_to"
                            value={AL_to}
                            onChange={AddProChange}
                            className="rs-input"
                        />
                    </div>

                    <button className="rs-btn rs-btn--primary" onClick={AL_applyFilter}>
                        <i className="fas fa-search"></i>
                        بگەڕە
                    </button>

                    <div className="rs-field rs-field--grow">
                        <label className="rs-field__label" htmlFor="AL_search">
                            گەڕان (کۆد، ناوی کاڵا، هەموو خانەکان)
                        </label>
                        <input
                            id="AL_search"
                            type="text"
                            name="AL_search"
                            value={AL_search}
                            onChange={AL_onSearchChange}
                            className="rs-input"
                            placeholder="گەڕان بەپێی کۆد، ناوی کاڵا، بەکارهێنەر، بەها..."
                        />
                        {/* The search runs over the rows pulled for the current
                            date range, and that pull is capped so the browser is
                            never asked to hold the whole journal. When the range
                            holds more than the cap, say so instead of quietly
                            searching a slice of it. */}
                        {searching && AL_truncated ? (
                            <span className="rs-field__hint rs-field__hint--warn">
                                <i className="fas fa-exclamation-triangle"></i>
                                گەڕان تەنها لە دوایین <span className="rs-num">2,000</span>{" "}
                                تۆماری ئەم ماوەیەدایە — بۆ گەڕانی تەواو ماوەی بەروار
                                کەمبکەرەوە یان بەشێک هەڵبژێرە
                            </span>
                        ) : null}
                    </div>

                    <div className="rs-pager">
                        <span className="rs-pager__count">
                            {searching ? "دۆزرایەوە: " : "کۆی تۆمارەکان: "}
                            <span className="rs-num">
                                {searching ? AL_matchCount : AL_total}
                            </span>
                        </span>
                        <button
                            className="rs-btn rs-btn--ghost rs-btn--icon"
                            onClick={AL_pageminsone}
                            disabled={AL_page <= 1}
                            title="پێشوو"
                        >
                            <i className="fas fa-chevron-right"></i>
                        </button>
                        <span className="rs-pager__pos rs-num">
                            {AL_page} / {AL_pages}
                        </span>
                        <button
                            className="rs-btn rs-btn--ghost rs-btn--icon"
                            onClick={AL_pageplusone}
                            disabled={AL_page >= AL_pages}
                            title="دواتر"
                        >
                            <i className="fas fa-chevron-left"></i>
                        </button>
                    </div>
                </div>
            );
        }}
    </ProductConsumer>
);

export default FillDetailAuditLog;
